export const DEFAULT_WIDTH = 38
export const DEFAULT_HEIGHT = 38
